import { render } from "./BarraTransicaoDeEscalas.vue?vue&type=template&id=34385bec&scoped=true&ts=true"
import script from "./BarraTransicaoDeEscalas.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarraTransicaoDeEscalas.vue?vue&type=script&setup=true&lang=ts"

import "./BarraTransicaoDeEscalas.vue?vue&type=style&index=0&id=34385bec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34385bec"],['__file',"src/common/BarraTransicaoDeEscalas/BarraTransicaoDeEscalas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34385bec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34385bec', __exports__)) {
    api.reload('34385bec', __exports__)
  }
  
  module.hot.accept("./BarraTransicaoDeEscalas.vue?vue&type=template&id=34385bec&scoped=true&ts=true", () => {
    api.rerender('34385bec', render)
  })

}


export default __exports__